export default "__VITE_ASSET__4103d2cd__"